import { useTranslations } from '@vocab/react';
import { Alert, Box, Text } from 'braid-design-system';

import translations from '../../locales.vocab';

import DefaultError from './defaultError';

export interface Props {
  transactionErrorMessage: string | undefined;
}

// These are the translations that require special handling where text contains anchor tags
const requireSpecialHandling = ['order.error.payment.error'];

const TransactionError = ({ transactionErrorMessage }: Props) => {
  const { t } = useTranslations(translations);

  // when transactionErrorMessage is falsy, don't render anything
  if (!Boolean(transactionErrorMessage)) {
    return <></>;
  }

  // when error message contains special elements that needs to be rendered differently
  const isRequireSpecialHandling = transactionErrorMessage
    ? requireSpecialHandling.includes(transactionErrorMessage)
    : false;

  // fallback when translation not found or translation contains special handling
  if (isRequireSpecialHandling || t(transactionErrorMessage as any) === '') {
    return (
      <Box>
        <Alert tone="critical">
          <DefaultError />
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      <Alert tone="critical">
        <Text>{t(transactionErrorMessage as any)}</Text>
      </Alert>
    </Box>
  );
};

export default TransactionError;
